import { __assign } from './../../_node_modules/tslib/tslib.es6.js';
import { isValidObject } from "./utils/valid-properties.js";
import { RevenueProperty } from "../../../analytics-types/lib/esm/event.js";
var Revenue = (
  /** @class */
  function() {
    function Revenue2() {
      this.productId = "";
      this.quantity = 1;
      this.price = 0;
    }
    Revenue2.prototype.setProductId = function(productId) {
      this.productId = productId;
      return this;
    };
    Revenue2.prototype.setQuantity = function(quantity) {
      if (quantity > 0) {
        this.quantity = quantity;
      }
      return this;
    };
    Revenue2.prototype.setPrice = function(price) {
      this.price = price;
      return this;
    };
    Revenue2.prototype.setRevenueType = function(revenueType) {
      this.revenueType = revenueType;
      return this;
    };
    Revenue2.prototype.setRevenue = function(revenue) {
      this.revenue = revenue;
      return this;
    };
    Revenue2.prototype.setEventProperties = function(properties) {
      if (isValidObject(properties)) {
        this.properties = properties;
      }
      return this;
    };
    Revenue2.prototype.getEventProperties = function() {
      var eventProperties = this.properties ? __assign({}, this.properties) : {};
      eventProperties[RevenueProperty.REVENUE_PRODUCT_ID] = this.productId;
      eventProperties[RevenueProperty.REVENUE_QUANTITY] = this.quantity;
      eventProperties[RevenueProperty.REVENUE_PRICE] = this.price;
      eventProperties[RevenueProperty.REVENUE_TYPE] = this.revenueType;
      eventProperties[RevenueProperty.REVENUE] = this.revenue;
      return eventProperties;
    };
    return Revenue2;
  }()
);
export {
  Revenue
};
//# sourceMappingURL=revenue.js.map
